export default function useNumberFormatter() {
    const formatter = Intl.NumberFormat("fa-IR");
    return formatter;
}
